import KnowCredListHeader from "./knowCredListHeader"

export default KnowCredListHeader
